import * as React from 'react';
import Attach from "./attach";
import Activity from './activity';
import Activityies from './activityies';
import AssociatedParty from './associatedParty';
import Workkards from './workkards';
import Workkard from './workkard';
import ApprovalIcons from './approvalIcons';
import InboxIcons from './inboxIcons';
import MercuryIcons from './mercuryIcons';
import Dashboard from './dashboard';
import Views from './views';
import Diary from './diary';
import Diaryies from './diaryies';
import Diaries from './diaries';
import Logs from './logs';
import Note from './note';
import Filter from './filter';
import Search from './search';
import Add from './add';
import Arrow from './arrow';
import Chev from './chev';
import Thumbnail from './thumbnail';
import Bell from './bell';
import LetterIcon from './letterIcon';
import WorkkardMenu from './workkardMenu';
import ViewMenu from './viewMenu';
import DashboardMenu from './dashboardMenu';
import LeaderboardMenu from './leaderboardMenu';
import BulkInboxMenu from './bulkinbox';
import AdminMenu from './adminMenu';
import CloseActivity from './closeActivity';
import WorkkardActivity from './workkardActivity';
import FaqMenu from './faqMenu';
import Close from './close';
import Upascendings from './Upascendings';
import Decendings from './Decendings';
import A2ZSort from './A2ZSort';
import Z2ASort from './Z2ASort';
import CombinedView from './combinedView';
import Delete from './delete';
import DownArrow from './downArrow';
import SelectArrow from './selectArrow';
import Edit from './edit';
import EditActive from './editActive';
import Expand from './expand';
import Excel from './excel';
import Public from './public';
import Print from './print';
import SelectMore from './selectMore';
import Clone from './clone';
import Copy from './copy';
import Collapse from './collapse';
import Pdf from './pdf';
import UserPic from './userPic';
import UserNum from './userNum';
import More from './more';
import Notification from './notification';
import BellNotification from './bellNotification';
import Info from './info';
import CloseCircle from './closeCircle';
import Review from './review';
import Save from './save';
import Check from './check';
import Download from './download';
import Video from './video';
import Largeview from './largeView';
import Thumbview from './thumbView';
import CloseFilled from './closeFilled';
import Reset from './reset';
import ErrorCircle from './errorCircle';
import MaliciousFile from './maliciousFile';
import NoVideo from './no_video';
import WorkkardDetail from './workkarddetail';
import AssociatedWorkkards from './associatedworkkards';
import ChangeOwners from './changeowners';
import ToastError from './toastError';
import ToastSuccess from './toastSuccess';
import ToastContact from './toastContact';
import ToastMessage from './toastMessage';
import WarningMessage from './warningMessage';
import InfoActivity from './infoActivity';
import Multicheck from './multiCheck';
import Email from './email';
import Mobile from './mobile';
import Flag from './flag';
import Org from './org';
import City from './city';
import Zip from './zip';
import Fax from './fax';
import ResolutionIcon from './resolutionIcon';
import UploadPdf from './uploadpdf';
import UploadWord from './uploadword';
import UploadExcel from './uploadexcel';
import UploadDefault from './uploaddefault';
import UploadTxt from './uploadtxt';
import UploadCapture from './uploadcapture';
import UploadMsg from './uploadmsg';
import UploadEsx from './uploadesx';
import UploadPpt from './uploadppt';
import UploadZip from './uploadzip';
import UploadAudio from './uploadaudio';
import UploadVideo from './uploadvideo';
import Sort from "./sort";
import SortbyOld from "./sortbyOld";
import CalenderIcon from "./calenderIcon";
import TourAdd from './tourIcons/add-icon';
import TourExpand from "./tourIcons/expand-icon";
import TourArrow from "./tourIcons/arrow-icon";
import Reorder from "./reorder";
import Grid from "./grid";
import SingleLayout from "./singleLayout";
import TwoLayout from "./twoLayout";
import ThreeLayout from "./threeLayout";
import Decending from "./decending";
import Ascending from "./ascending";
import Nfbell from "./nfBell";
import Nfnoteadded from "./nfNoteAdded";
import Nfreassign from "./nfReassign";
import OrgAccess from "./orgAccess";
import Recent from "./recent";
import JumpArrow from "./jumpArrow";
import Cclogo from "./cclogo";
import CcGlobalLogo from "./ccglobalLogo";
import CasheLogo from "./casheLogo";
import Emptynote from "./emptynote";
import Emptyfile from "./emptyfile";
import Emptydiary from "./emptydiary";
import Emptylog from "./emptylog";
import Emptyparty from "./emptyparty";
import Emptyactivity from "./emptyactivity";
import Emptyworkkard from "./emptyWorkkard";
import Emptyowner from "./emptyOwner";
import ErrorScreen from "./errorScreen";
import EmptySearchActivity from "./emptySearchActivities";
import Refresh from "./refresh";
import UserDetail from "./userdetail";
import EmptyCombinedView from "./emptyCombinedView";
import NoRecordsIllustration from "./noRecordsIllustration";
import Clock from "./clock";
import Personal from "./personal";
import EmptyDiaryWhiteBg from "./emptyDiaryWhiteBg";
import Policies from './policies';
import Requests from './requests';
import Reports from './reports';
import Mercury from './mercury';
import Drag from "./drag";
import FaqCircle from "./faqCircle";
import NewPage from "./newPage";
import Send from "./send";
import ManageProfile from './manageProfile';
import AdminSettings from './adminSettings';
import Theme from './themes';
import UserContract from './userContract';
import PrivacyPolicy from './privacyPolicy';
import Help from './help';
import Logout from './logout';
import Sortuparrow from './sortuparrow';

export default class Icons extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    switch (this.props.name) {
      case "Sortuparrow":
        return <Sortuparrow {...this.props} />;
      case "ManageProfile":
        return <ManageProfile {...this.props} />;
      case "AdminSettings":
        return <AdminSettings {...this.props} />;
      case "Theme":
        return <Theme {...this.props} />;
      case "UserContract":
        return <UserContract {...this.props} />;
      case "PrivacyPolicy":
        return <PrivacyPolicy {...this.props} />;
      case "Help":
        return <Help {...this.props} />;
      case "Logout":
        return <Logout {...this.props} />;
      case "NewPage":
        return <NewPage {...this.props} />;
      case "Send":
        return <Send {...this.props} />;
      case "UserDetail":
        return <UserDetail {...this.props} />;
      case "FaqCircle":
        return <FaqCircle {...this.props} />;
      case "Refresh":
        return <Refresh {...this.props} />;
      case "Cclogo":
        return <Cclogo {...this.props} />;
      case "CcGlobalLogo":
        return <CcGlobalLogo {...this.props} />;
      case "CasheLogo":
        return <CasheLogo {...this.props} />;
      case "JumpArrow":
        return <JumpArrow {...this.props} />;
      case "Recent":
        return <Recent {...this.props} />;
      case "OrgAccess":
        return <OrgAccess {...this.props} />;
      case "Nfbell":
        return <Nfbell {...this.props} />;
      case "LetterIcon":
        return <LetterIcon {...this.props} />;
      case "Emptynote":
        return <Emptynote {...this.props} />;
      case "Emptyactivity":
        return <Emptyactivity {...this.props} />;
      case "Emptyfile":
        return <Emptyfile {...this.props} />;
      case "Emptydiary":
        return <Emptydiary {...this.props} />;
      case "Emptylog":
        return <Emptylog {...this.props} />;
      case "Emptyparty":
        return <Emptyparty {...this.props} />;
      case "Nfnoteadded":
        return <Nfnoteadded {...this.props} />;
      case "Nfreassign":
        return <Nfreassign {...this.props} />;
      case "ascending":
        return <Ascending {...this.props} />;
      case "decending":
        return <Decending {...this.props} />;
      case "reorder":
        return <Reorder {...this.props} />;
      case "grid":
        return <Grid {...this.props} />;
      case "SingleLayout":
        return <SingleLayout {...this.props} />
      case "TwoLayout":
        return <TwoLayout {...this.props} />
      case "ThreeLayout":
        return <ThreeLayout {...this.props} />
      case "fax":
        return <Fax {...this.props} />;
      case "zip":
        return <Zip {...this.props} />;
      case "city":
        return <City {...this.props} />;
      case "email":
        return <Email {...this.props} />;
      case "mobile":
        return <Mobile {...this.props} />;
      case "flag":
        return <Flag {...this.props} />;
      case "org":
        return <Org {...this.props} />;
      case "multiCheck":
        return <Multicheck {...this.props} />;
      case "errorcircle":
        return <ErrorCircle {...this.props} />;
      case "reset":
        return <Reset {...this.props} />;
      case "maliciousFile":
        return <MaliciousFile {...this.props} />;
      case "closeFilled":
        return <CloseFilled {...this.props} />;
      case "largeview":
        return <Largeview {...this.props} />;
      case "thumbview":
        return <Thumbview {...this.props} />;
      case "attach":
        return <Attach {...this.props} />;
      case "activity":
      case "activities":
        return <Activity {...this.props} />;
      case "activityies":
        return <Activityies {...this.props} />;
      case "associatedParty":
        return <AssociatedParty {...this.props} />;
      case "Upascendings":
        return <Upascendings {...this.props} />;
      case "Decendings":
        return <Decendings {...this.props} />;
      case "A2ZSort":
        return <A2ZSort {...this.props} />;
      case "Z2ASort":
        return <Z2ASort {...this.props} />;
      case "workkards":
        return <Workkards {...this.props} />;
      case "workkard":
        return <Workkard {...this.props} />;
      case "dashboard":
        return <Dashboard {...this.props} />;
      case "diary":
        return <Diary {...this.props} />;
      case "diaryies":
        return <Diaryies {...this.props} />;
      case "diaries":
        return <Diaries {...this.props} />;
      case "logs":
        return <Logs {...this.props} />;
      case "note":
        return <Note {...this.props} />;
      case "filter":
        return <Filter {...this.props} />;
      case "search":
        return <Search {...this.props} />;
      case "add":
        return <Add {...this.props} />;
      case "arrow":
        return <Arrow {...this.props} />;
      case "chev":
        return <Chev {...this.props} />;
      case "thumbnail":
        return <Thumbnail {...this.props} />;
      case "bell":
        return <Bell {...this.props} />;
      case "inboxIcons":
        return <InboxIcons {...this.props} />;
      case "mercuryIcons":
        return <MercuryIcons {...this.props} />;
      case "workkardMenu":
        return <WorkkardMenu {...this.props} />;
      case "views":
        return <Views {...this.props} />;
      case "viewMenu":
        return <ViewMenu {...this.props} />;
      case "dashboardMenu":
        return <DashboardMenu {...this.props} />;
      case "leaderboardMenu":
        return <LeaderboardMenu {...this.props} />;
      case "bulkinboxMenu":
        return <BulkInboxMenu {...this.props} />;
      case "adminMenu":
        return <AdminMenu {...this.props} />;
      case "closeActivity":
        return <CloseActivity {...this.props} />;
      case "workkardActivity":
        return <WorkkardActivity {...this.props} />;
      case "faqMenu":
        return <FaqMenu {...this.props} />;
      case "close":
        return <Close {...this.props} />;
      case "combinedView":
        return <CombinedView {...this.props} />;
      case "delete":
        return <Delete {...this.props} />;
      case "downArrow":
        return <DownArrow {...this.props} />;
      case "selectArrow":
        return <SelectArrow {...this.props} />;
      case "edit":
        return <Edit {...this.props} />;
      case "expand":
        return <Expand {...this.props} />;
      case "excel":
        return <Excel {...this.props} />;
      case "public":
        return <Public {...this.props} />;
      case "print":
        return <Print {...this.props} />;
      case "selectMore":
        return <SelectMore {...this.props} />;
      case "clone":
        return <Clone {...this.props} />;
      case "collapse":
        return <Collapse {...this.props} />;
      case "pdf":
        return <Pdf {...this.props} />;
      case "userPic":
        return <UserPic {...this.props} />;
      case "userNum":
        return <UserNum {...this.props} />;
      case "more":
        return <More {...this.props} />;
      case "notification":
        return <Notification {...this.props} />;
      case "bellNotification":
        return <BellNotification {...this.props} />;
      case "info":
        return <Info {...this.props} />;
      case "closeCircle":
        return <CloseCircle {...this.props} />;
      case "review":
        return <Review {...this.props} />;
      case "save":
        return <Save {...this.props} />;
      case "check":
        return <Check {...this.props} />;
      case "download":
        return <Download {...this.props} />;
      case "video":
        return <Video {...this.props} />;
      case "no_video":
        return <NoVideo {...this.props} />;
      case "WorkkardDetail":
        return <WorkkardDetail {...this.props} />;
      case "associatedWorkkards":
        return <AssociatedWorkkards {...this.props} />;
      case "changeOwners":
        return <ChangeOwners {...this.props} />
      case "toastError":
        return <ToastError {...this.props} />
      case "toastSuccess":
        return <ToastSuccess {...this.props} />
      case "toastContact":
        return <ToastContact {...this.props} />
      case "toastMessage":
        return <ToastMessage {...this.props} />
      case "warningMessage":
        return <WarningMessage {...this.props} />
      case "infoActivity":
        return <InfoActivity {...this.props} />
      case "resolutionIcon":
        return <ResolutionIcon {...this.props} />
      case "uploadPdf":
        return <UploadPdf {...this.props} />
      case "uploadWord":
        return <UploadWord {...this.props} />
      case "uploadTxt":
        return <UploadTxt {...this.props} />
      case "uploadCapture":
        return <UploadCapture {...this.props} />
      case "uploadExcel":
        return <UploadExcel {...this.props} />
      case "uploadMsg":
        return <UploadMsg {...this.props} />
      case "uploadDefault":
        return <UploadDefault {...this.props} />
      case "uploadEsx":
        return <UploadEsx {...this.props} />
      case "uploadPpt":
        return <UploadPpt {...this.props} />
      case "uploadZip":
        return <UploadZip {...this.props} />
      case "uploadAudio":
        return <UploadAudio {...this.props} />
      case "uploadVideo":
        return <UploadVideo {...this.props} />
      case "sort":
        return <Sort {...this.props} />
      case "SortbyOld":
        return <SortbyOld {...this.props} />
      case "calenderIcon":
        return <CalenderIcon {...this.prop} />
      case "tourAdd":
        return <TourAdd {...this.props} />
      case "tourExpand":
        return <TourExpand {...this.props} />
      case "tourArrow":
        return <TourArrow {...this.props} />
      case "copy":
        return <Copy {...this.props} />
      case "Emptyworkkard":
        return <Emptyworkkard {...this.props} />
      case "Emptyowner":
        return <Emptyowner {...this.props} />;
      case "Errorscreen":
        return <ErrorScreen {...this.props} />;
      case "EmptySearchActivity":
        return <EmptySearchActivity {...this.props} />;
      case "EmptyCombinedView":
        return <EmptyCombinedView {...this.props} />;
      case "editActive":
        return <EditActive {...this.props} />;
      case "NoRecordsIllustration":
        return <NoRecordsIllustration {...this.props} />;
      case "clock":
        return <Clock {...this.props} />;
      case "personal":
        return <Personal {...this.props} />;
      case "emptyDiaryWhiteBg":
        return <EmptyDiaryWhiteBg {...this.props} />;
      case "approvalIcons":
        return <ApprovalIcons {...this.props} />;
      case "policies":
        return <Policies {...this.props} />;
      case "requests":
        return <Requests {...this.props} />;
      case "reports":
        return <Reports {...this.props} />;
      case "mercury":
        return <Mercury {...this.props} />;
      case "drag":
        return <Drag {...this.props} />;
      default:
        return '';
    }
  }
}